import { render, staticRenderFns } from "./quillTextLight.vue?vue&type=template&id=17dd050c&scoped=true"
import script from "./quillTextLight.vue?vue&type=script&lang=js"
export * from "./quillTextLight.vue?vue&type=script&lang=js"
import style0 from "./quillTextLight.vue?vue&type=style&index=0&id=17dd050c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd050c",
  null
  
)

export default component.exports